<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <h1 class="page-title pull-left">User Settings</h1>
        <div class="pull-right">
          <button class="pointer btn btn-lg btn-primary" v-on:click="form.showEdit({})">Create New</button>
        </div>
      </div>
    </div>

    <div class="panel">
      <div class="panel-heading">
        <h3 class="panel-title">All</h3>
      </div>
      <div class="panel-body">
        <div class="col-xs-12 table-responsive">
          <table class="table table-striped table-bordered table-hover table-fixed">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Contracts</th>
                <th width="120"></th>
              </tr>
            </thead>
            <tbody>

            <tr v-for="item in form.list">
              <td>{{ item.attributes.firstName }} {{ item.attributes.lastName}}</td>
              <td>{{ item.attributes.email }}</td>
              <td>{{ item.attributes.roleId }}</td>
              <td>
                <ul>
                  <li v-for="contract in item.attributes.contracts">
                    {{ contractName(contract) }}
                  </li>
                </ul>
              </td>
              <td>
                <a class="pointer text-primary" v-on:click="form.showEdit({id: item.id})" title="edit"><i class="fa fa-pencil mr-10"></i></a>
                <a class="pointer text-danger" v-on:click="form.destroy(item.id)" title="delete"><i class="fa fa-times"></i></a>
              </td>
            </tr>


            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" role="dialog" id="edit">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">{{form.modal.title}}</h4>
          </div>
          <div class="modal-body">
            <form @submit.prevent="form.onSubmit({ updateStore: true, updateList:true })" @keydown="form.errors.clear($event.target.id)">
              <input type="hidden" name="id" v-model="form.id">

              <div class="form-group" :class="{'has-error': form.errors.has('firstName') }">
                <label class="control-label">First Name</label>
                <input type="text" class="form-control" id="firstName" v-model="form.data.firstName" required>
                <span class="help-block" v-if="form.errors.has('firstName')" v-text="form.errors.get('firstName')"></span>
              </div>

              <div class="form-group" :class="{'has-error': form.errors.has('lastName') }">
                <label class="control-label">Last Name</label>
                <input type="text" class="form-control" id="lastName" v-model="form.data.lastName" required>
                <span class="help-block" v-if="form.errors.has('lastName')" v-text="form.errors.get('lastName')"></span>
              </div>

              <div class="form-group" :class="{'has-error': form.errors.has('email') }">
                <label class="control-label">Email</label>
                <input type="email" class="form-control" id="email" v-model="form.data.email" required>
                <span class="help-block" v-if="form.errors.has('email')" v-text="form.errors.get('email')"></span>
              </div>

              <div class="form-group" :class="{'has-error': form.errors.has('password') }">
                <label class="control-label">Password</label>
                <input type="text" class="form-control" id="password" v-model="form.data.password">
                <span class="help-block">Optional. Won't change if left blank.</span>
                <span class="help-block" v-if="form.errors.has('password')" v-text="form.errors.get('password')"></span>
              </div>

              <div class="form-group" :class="{'has-error': form.errors.has('roleId') }">
                <label class="control-label">Role</label>
                <select class="form-control" id="roleId" v-model="form.data.roleId">
                  <option>Admin</option>
                  <option>Contract</option>
                  <option>Report</option>
                </select>
                <span class="help-block" v-if="form.errors.has('roleId')" v-text="form.errors.get('roleId')"></span>
              </div>

              <div class="form-group" :class="{'has-error': form.errors.has('contracts') }">
                <label class="control-label">Contracts</label>
                <div v-for="(contract, index) in form.data.contracts">
                  <div class="input-group">
                    <span class="input-group-addon">{{index + 1}}</span>
                    <select class="form-control" v-model="form.data.contracts[index]">
                      <option></option>
                      <option v-for="c in contracts" v-bind:value="c.id">{{c.attributes.name}}</option>
                    </select>
                    <span class="input-group-addon"><i class="fa fa-trash pointer" v-on:click="form.removeContract(index)" title="Remove contract"></i></span>
                  </div>
                </div>
                <button class="btn btn-small" v-on:click.prevent="form.addContract()" title="Add contract"><i class="fa fa-plus"></i></button>
                <span class="help-block" v-if="form.errors.has('contracts')" v-text="form.errors.get('contracts')"></span>
              </div>

              <loading-button :loading="form.loading" class="btn btn-primary" :disabled="form.errors.any()">Save</loading-button>
              <button type="button" class="btn btn-default" data-dismiss="modal">cancel</button>
            </form>
          </div>
          <div class="modal-footer">
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->

  </div>
</template>

<script>
  import UsersService from '@/services/UserService';
  import Form from '@/utils/form';
  import LoadingButton from '@/components/loading-button';


  export default {
    name: 'users',

    components: {
      LoadingButton
    },

    data() {
      return {
        form: new Form(
          UsersService,
          {
            firstName: null,
            lastName: null,
            email: null,
            roleId: null,
            password: null,
            contracts: []
          })
      }
    },

    computed: {
      contracts() {
        return this.$store.getters.contracts;
      }
    },

    methods: {
      contractName(id) {
        return this.$store.getters.contractNameById(id)
      },
    },

    mounted() {
      this.form.getList();
      if (!this.$store.getters.isAdmin) {
        this.$router.push({name: 'site-and-activity-map'});
      }
    }

  }
</script>

<style lang="scss">

</style>
